import moment from "moment";

import { evbus, EVENTS } from "@/shared/evbus";
import startCase from "@/shared/strings";
import timeFormat from "@/shared/timeFormat";

export default {
  data() {
    return {
      columnsWidths: []
    };
  },
  methods: {
    specialDate(dt, start) {
      let fdt = null;
      if (typeof dt.format !== "undefined") {
        fdt = dt.format("YYYY-MM-DDTHH:mm:ss");
      } else {
        fdt = moment(dt).format("YYYY-MM-DDTHH:mm:ss");
      }
      fdt = fdt.split("T")[0];
      if (start) {
        return `${fdt}T00:00:00.000Z`;
      }
      return `${fdt}T23:59:59.999Z`;
    },
    columnsWidthChanged(ths) {
      const tmp = [];
      ths.forEach(item => {
        const columnWidth = Number(parseInt(item.style.width));
        if (columnWidth != Number.NaN) {
          tmp.push(columnWidth);
        } else {
          tmp.push(0);
        }
      });
      this.columnsWidths = tmp;
    },
    doSearch(data) {
      this.filter = data.filter;
      this.filterField = data.filterField;
      this.refresh();
    },
    serialize(obj) {
      const str = [];
      for (const p in obj)
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
    round(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;

      const res = Number(
        Math.round(value + "e" + decimals) + "e-" + decimals
      ).toFixed(decimals);
      return res.replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;
      const tmp = value / 10000;

      const res = Number(
        Math.round(tmp + "e" + decimals) + "e-" + decimals
      ).toFixed(decimals);
      return res.replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    mom_unix(val) {
      if (!val)
        return {
          format() {
            return "";
          }
        };
      return moment.unix(val / 1e9);
    }
  },

  computed: {
    tableDateLong() {
      return timeFormat.tableDateLong;
    },
    tableDateMedium() {
      return timeFormat.tableDateMedium;
    },
    tableDateShort() {
      return timeFormat.tableDateShort;
    },
    paginationOpts() {
      return [
        {
          value: 5
        },
        {
          value: 10
        },
        {
          value: 15
        },
        {
          value: 25
        },
        {
          value: 50
        }
      ];
    },
    filterFields() {
      const tmp = [];
      this.fields.forEach(element => {
        if (element.ignore) return;
        if (typeof element.label != "undefined") {
          tmp.push({
            label: element.label,
            value: element.key
          });
        } else {
          tmp.push({
            label: startCase(element.key),
            value: element.key
          });
        }
      });
      return tmp;
    }
  },
  beforeMount() {
    let from = this.$store.getters["global/fromURI"];
    from = from ? from.path : "";
    let current = this.$route.path;

    let processDate = false;
    if (from.indexOf(current) == 0) {
      processDate = true;
    }

    if (this.tableName && localStorage.getItem(`${this.tableName}.fields`)) {
      const state = JSON.parse(
        localStorage.getItem(`${this.tableName}.fields`)
      );
      if (typeof state.columns != "undefined") {
        state.columns.forEach(item => {
          this.fields.forEach(field => {
            if (typeof field.class != "undefined") {
              if (item.k == field.key) {
                field.class = field.class.replace("d-none", "");
                if (!item.c) {
                  field.class = field.class + " d-none";
                }
              }
            }
          });
        });
      }
      if (typeof state.columnsWidths != "undefined") {
        this.fields.forEach((field, index) => {
          if (state.columnsWidths[index]) {
            field.thStyle = `width: ${state.columnsWidths[index]}px`;
          }
        });
      }
      if (this.$route.query && this.$route.query.lid) {
        return;
      }
      if (
        typeof state.filters != "undefined" &&
        typeof this.filterOptions != "undefined"
      ) {
        state.filters.forEach(item => {
          this.filterOptions.forEach(field => {
            if (item.k == field.field) {
              if (field.type != "date") {
                if (
                  typeof field.options !== "undefined" &&
                  field.options.length == 0
                ) {
                  field.selected = item.v;
                } else {
                  if (
                    typeof field.selected !== "undefined" &&
                    field.selected.length == 0
                  ) {
                    if (typeof field.options !== "undefined") {
                      field.options.forEach(opt => {
                        if (item.v.indexOf(opt.value) > -1) {
                          field.selected.push(JSON.parse(JSON.stringify(opt)));
                        }
                      });
                    }
                  }
                }
              } else {
                if (!item.stateIgnore) {
                  if (processDate) {
                    if (item.v.startDate && item.v.endDate) {
                      field.selected.startDate = item.v.startDate;
                      field.selected.endDate = item.v.endDate;
                    }
                  }
                }
              }
            }
          });
        });
      }
    }
  },
  beforeDestroy() {
    if (this.tableName) {
      const state = {
        columns: [],
        filters: [],
        columnsWidths: []
      };
      this.fields.forEach(item => {
        if (item.key) {
          state.columns.push({
            k: item.key,
            c:
              typeof item.class != "undefined" &&
                item.class.indexOf("d-none") > -1
                ? false
                : true,
            l: item.label
          });
        }
      });
      if (typeof this.columnsWidths != "undefined") {
        this.columnsWidths.forEach(item => {
          state.columnsWidths.push(item);
        });
      }
      if (typeof this.filterOptions != "undefined") {
        this.filterOptions.forEach(item => {
          if (!item.stateIgnore) {
            state.filters.push({
              k: item.field,
              v: item.selected
            });
          }
        });
      }
      localStorage.setItem(`${this.tableName}.fields`, JSON.stringify(state));
    }
  },
  mounted() {
    if (this.redirect && typeof this.redirect === "function") {
      this.addCB = this.redirect.bind(this);
      evbus.on(EVENTS.DO_ADD, this.addCB);
    }

    this.doSearchCB = this.doSearch.bind(this);
    evbus.on(EVENTS.DO_SEARCH, this.doSearchCB);

    if (!this.preventLabel) {
      evbus.emit(EVENTS.SHOW_SUBHEADER_OPTIONS, {
        showAdd: true,
        addLabel: this.addLabel,
        searchFields: this.filterFields,
        total: 0
      });
    }
  },
  destroyed() {
    if (!this.preventLabel) {
      evbus.emit(EVENTS.HIDE_SUBHEADER_OPTIONS);
    }
    evbus.remove(EVENTS.DO_ADD, this.addCB);
    evbus.remove(EVENTS.DO_SEARCH, this.doSearchCB);
  },
  watch: {
    totalRows(val) {
      evbus.emit(EVENTS.UPDATE_SUBHEADER_OPTIONS, {
        total: this.totalRows
      });
    }
  }
};
